import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=516d198f&"
import script from "./GridView.vue?vue&type=script&lang=js&"
export * from "./GridView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516d198f')) {
      api.createRecord('516d198f', component.options)
    } else {
      api.reload('516d198f', component.options)
    }
    module.hot.accept("./GridView.vue?vue&type=template&id=516d198f&", function () {
      api.rerender('516d198f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/GridView.vue"
export default component.exports